import type * as api from '@gitbook/api-client';

import { apiResource, useSuspensePaginatedAPIQuery } from '../../state';

/**
 * Queries a paginated list of Comment Replies for the given Space or Change Request.
 */
export function useListPaginatedCommentReplies(props: {
    spaceId: string;
    commentId: string;
    changeRequestId?: string;
}): [api.CommentReply[], (() => Promise<void>) | undefined, (() => Promise<void>) | undefined] {
    const { spaceId, commentId, changeRequestId } = props;

    const {
        data: { items: commentReplies },
        next,
        previous,
    } = useSuspensePaginatedAPIQuery(
        changeRequestId
            ? apiResource('listCommentRepliesInChangeRequest', {
                  spaceId,
                  commentId,
                  changeRequestId,
              })
            : apiResource('listCommentRepliesInSpace', {
                  spaceId,
                  commentId,
              })
    );

    return [commentReplies, next, previous];
}
